import React from 'react';

import { CircleX } from 'lucide-react';

import { closeModal } from '@/components/modals/modals.utils';
import { ImageCarousel } from '@/components/ui/image-carousel';
import useClickOutside from '@/hooks/use-click-outside';

import { ModalBase } from '../../../components/modals/modals-base';

export type ViewMediaModalType = {
  files: File[];
  fileName: string;
};

export interface ViewMediaModalProps {
  images: {
    creatorId: string;
    deletedAt: string | null;
    estateId: string;
    fileName: string;
    name: string;
    id: string;
    createdAt: string | null;
    mediaId: string | null;
    updatedAt: string | null;
    fileType: string | null;
  }[];
  preselectedCurrentIndex: number;
}

export const ViewMediaModal: React.FC<ViewMediaModalProps> = (props) => {
  const modalContainerRef = useClickOutside<HTMLDivElement>(closeModal, true);

  return (
    <ModalBase
      ref={modalContainerRef}
      className="flex max-h-full max-w-4xl flex-col overflow-hidden !p-4"
    >
      <CircleX
        onClick={closeModal}
        className="m-2 ml-auto cursor-pointer max-md:mt-0 [&_*]:stroke-primary"
        width={35}
        height={35}
      />
      <div className="flex h-full items-center justify-center overflow-hidden">
        <ImageCarousel {...props} />
      </div>
    </ModalBase>
  );
};
